import {CUSTODIANS} from '@client/util/constants/custodian';
import {RequestInitiatedFrom} from '@simpleinvest/ms-core-sdk';

export interface SimpleAccountType {
  account_type_id: number;
  account_name: string;
  account_type?: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export const normalizeAccountTypes = (response: any): SimpleAccountType[] => {
  const body = response.data || response;

  return body.map((accountType) => ({
    account_type_id: accountType.accountTypeId || accountType.account_type_id,
    account_name: accountType.accountTypeName || accountType.featureName || accountType.account_name,
    account_type: accountType.accountType,
  }));
};

export interface LegacyAccountRequest {
  account_type: number;
  cdo_initiated: number;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  batch_ID?: number;
  rep_code: string;
  account_name: string;
  account_type_name: string;
  goal_id?: number;
  rollover_ira: number;
  request_initiated_from: string;
  request_id: number;
  cust_id: number;
  status: number;
  account_number?: string;
  bene_cc: number;
  no_bene_selected: number;
  no_trusted_contact: number;
  acc_type_cc: number;
  diff_mail_add: number;
  per_aff_cc: number;
  per_aff_spf: number;
  per_aff_ptc: number;
  per_aff_fai: number;
  client_is_cc: number;
  inv_profile_cc: number;
  faiDetails?: unknown;
  beneficiaries: unknown[];
  trustedContacts: unknown[];
}

// TODO: Should we store all account types somewhere and use that rather than selectedAccount?
// This method should only be used by `initAccountRequest` in src/models/store/onboarding/index.js
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createAccountRequestToLegacy = (data: any, selectedAccount: SimpleAccountType): LegacyAccountRequest => ({
  account_type: selectedAccount.account_type_id,
  cdo_initiated: data.cdoInitiated ? 1 : 0,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  batch_ID: null,
  rep_code: data.repCode,
  account_name: data.accountName,
  account_type_name: selectedAccount.account_name,
  goal_id: null,
  rollover_ira: data.rolloverIRA ? 1 : 0,
  request_initiated_from: RequestInitiatedFrom.CLIENT_DASHBOARD,
  request_id: data.id,
  cust_id: Object.values(CUSTODIANS).find(({code}) => code === data.custodian).id,
  status: data.accountStatus,
  account_number: null,
  bene_cc: 0,
  no_bene_selected: 0,
  no_trusted_contact: 0,
  acc_type_cc: 0,
  diff_mail_add: 0,
  per_aff_cc: 0,
  per_aff_spf: 0,
  per_aff_ptc: 0,
  per_aff_fai: 0,
  client_is_cc: 0,
  inv_profile_cc: 0,
  faiDetails: null,
  beneficiaries: [],
  trustedContacts: [],
});
